/** Situações do representante */
export interface RepresentanteSituacao {
    id: number;
    nome: string;
    color: string;
    badge: string;
}

export const representanteAtivo: RepresentanteSituacao = {
    id: 1,
    nome: 'Ativo',
    color: '#20b75d',
    badge: 'badge badge-representante-situacao-ativo'
};
export const representanteInativo: RepresentanteSituacao = {
    id: 2,
    nome: 'Inativo',
    color: '#f55e59',
    badge: 'badge badge-representante-situacao-inativo'
};
/*export const representantePotencial: RepresentanteSituacao = {
    id: 3,
    nome: 'Potencial',
    color: '#237dd8',
    badge: 'badge badge-representante-situacao-potencial'
};*/

export const representanteSituacoes: RepresentanteSituacao[] = [
    representanteAtivo,
    representanteInativo
];


/** Verifica se o status do Representante é igual a Ativo */
export function isRepresentanteAtivo(situacao: number): boolean {
    return situacao === representanteAtivo.id;
}

/** Verifica se o status do Representante é igual a Inativo */
export function isRepresentanteInativo(situacao: number): boolean {
    return situacao === representanteInativo.id;
}

/** Verifica se o status do Representante é igual a Potencial */
/*export function isRepresentantePotencial(situacao: number): boolean {
    return situacao === representantePotencial.id;
}*/
